import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, OnChanges, OnInit, SimpleChanges, ViewContainerRef } from '@angular/core';
import { util } from '../../classes/util';
import { BooleanConverter, InputConverter } from '../../inputConverter';
import { AreaUnits, DistanceUnits, FillStyleOptions, LineStyleOptions } from '../../selectionOptions';
import { BufferService } from '../../services/buffer.service';
import { LayerService } from '../../services/layer.service';
import { SpatialQueryService } from '../../services/spatialQuery.service';
import { LogLevel } from '../../types';
import { BaseComponent } from '../base.component';
var BufferComponent = /** @class */ (function (_super) {
    tslib_1.__extends(BufferComponent, _super);
    function BufferComponent(_vcr, bufferService, layerService, spatialQueryService, cdr, LoggingService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.bufferService = bufferService;
        _this.layerService = layerService;
        _this.spatialQueryService = spatialQueryService;
        _this.cdr = cdr;
        _this.LoggingService = LoggingService;
        _this.createBuffer = _this.buffer.bind(_this);
        _this.showOnlyApplicationUserMaps = false;
        _this._active = false;
        _this.showSettings = {
            type: true,
            distance: true,
            distanceUnit: true,
            areaUnit: true,
            fillType: true,
            fillColor: true,
            outlineType: true,
            outlineColor: true
        };
        _this.buffered = new EventEmitter();
        _this.buffering = false;
        _this.warningMsg = null;
        _this.warningLimit = 4;
        _this._multiBuffer = 'false';
        return _this;
    }
    Object.defineProperty(BufferComponent.prototype, "active", {
        get: function () { return this._active; },
        set: function (value) {
            this._active = BooleanConverter(value);
            this._active ? this.activate() : this.deactivate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BufferComponent.prototype, "geometry", {
        get: function () { return this._geometry; },
        set: function (value) {
            this._geometry = value;
            if (value) {
                this._layer = null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BufferComponent.prototype, "layer", {
        get: function () { return this._layer; },
        set: function (value) {
            this._layer = value;
            if (value) {
                this._geometry = null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BufferComponent.prototype, "multiBuffer", {
        get: function () { return this._multiBuffer; },
        set: function (value) {
            this._multiBuffer = value;
            if (value === 'false') {
                this.bufferDistance = this.bufferDistance.toString().split(',')[0];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BufferComponent.prototype, "fillColorPickerRef", {
        set: function (el) { this.fillColorPicker = el; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BufferComponent.prototype, "outlineColorPickerRef", {
        set: function (el) { this.outlineColorPicker = el; },
        enumerable: true,
        configurable: true
    });
    BufferComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.bufferOptions = util.deepClone(this.bufferService.getDefaultBufferOptions());
                this.distanceUnits = DistanceUnits;
                this.areaUnits = tslib_1.__spread(AreaUnits);
                this.areaUnits.unshift({
                    name: 'Select a unit...',
                    value: null
                });
                this.fillTypes = FillStyleOptions;
                this.outlineTypes = LineStyleOptions;
                this.bufferDistance = this.bufferOptions.distance.toString();
                return [2 /*return*/];
            });
        });
    };
    BufferComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.mapView) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapView)];
                    case 1:
                        _a.mapView = _b.sent();
                        this.isReady();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BufferComponent.prototype.ngOnChanges = function (changes) {
        if (changes.mapLayers) {
            this.bufferableLayers = this.getBufferableLayers(this.mapView.map, changes.mapLayers.currentValue);
        }
    };
    BufferComponent.prototype.checkFilteredLayerWarning = function () {
        var newBufferCount = this.bufferDistance.toString().split(',').length;
        var newFilteredLayerCount = newBufferCount * (this.selectedLayers ? this.selectedLayers.length : 0);
        if (newBufferCount > 1 && newFilteredLayerCount > this.warningLimit) {
            this.warningMsg = "Map will have " + newFilteredLayerCount + " new filtered layers added. One for each combination of layer and buffer selected. Additional processing time may be required.";
        }
        else {
            this.warningMsg = null;
        }
    };
    BufferComponent.prototype.activate = function () {
        this.bufferableLayers = this.getBufferableLayers(this.mapView.map, this.mapLayers);
        this.selectedLayers = [];
        this.warningMsg = null;
    };
    BufferComponent.prototype.deactivate = function () {
        this.layer = null;
        this.geometry = null;
    };
    BufferComponent.prototype.isMultiBuffer = function () {
        return this.multiBuffer === 'true';
    };
    BufferComponent.prototype.getBufferableLayers = function (map, requestedLayers) {
        var _this = this;
        // Host may pass in requestedLayers with: layers/ids, empty list or no list.
        // We then: find matching layers, hide dropdown, or show all appropriate layers respectively.
        var bufferableLayers = map.layers.toArray().filter(function (x) {
            return (!requestedLayers || requestedLayers.find(function (y) { return y.id === x.id; }))
                && (!_this.layer || _this.layer.id !== x.id)
                && !x.mapcoreProps.isAOI
                && !_this.layerService.isTempLayer(x)
                && _this.layerService.getLayerType(x) !== 'graphics'; // No graphic layer support yet
        }).sort(function (a, b) { return a.mapcoreProps.name.localeCompare(b.mapcoreProps.name); });
        bufferableLayers.forEach(function (layer) {
            var genericLayer = layer;
            genericLayer.customLabel = genericLayer.name ? genericLayer.name : layer.mapcoreProps.name;
        });
        return bufferableLayers;
    };
    BufferComponent.prototype.buffer = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var bufferCompleted, buffers, results, graphicsLayers_1, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        bufferCompleted = false;
                        this.buffering = true;
                        this.warningMsg = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 8, 9, 10]);
                        this.bufferOptions.distance = this.bufferDistance.toString().split(',').map(function (d) { return Number(d.trim()); });
                        buffers = void 0;
                        if (!this.layer) return [3 /*break*/, 3];
                        this.bufferOptions.unionResults = true;
                        return [4 /*yield*/, this.bufferService.getLayerBuffers(this.layer, this.bufferOptions)];
                    case 2:
                        results = _a.sent();
                        if (results && results.length) {
                            if (!results[0].featureCount) {
                                this.warningMsg = 'Selected layer has no features to buffer.';
                            }
                            else if (results[0].featureCount > this.bufferService.bufferFeatureLimit) {
                                this.warningMsg = "Selected layer has greater than " + this.bufferService.bufferFeatureLimit + " features. Please filter layer to " + this.bufferService.bufferFeatureLimit + " or less features before buffering.";
                            }
                            buffers = results[0].buffers;
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        if (!this.geometry) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.bufferService.getGeometryBuffers(this.geometry, this.bufferOptions)];
                    case 4:
                        buffers = _a.sent();
                        _a.label = 5;
                    case 5:
                        if (!buffers.length) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.bufferService.addBufferToMap(buffers, this.bufferOptions)];
                    case 6:
                        graphicsLayers_1 = _a.sent();
                        if (this.selectedLayers && this.selectedLayers.length) {
                            graphicsLayers_1.forEach(function (bufferLayer) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var joinedGeometries, selectedLayers, results, spatialQueryParams, title;
                                var _this = this;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            joinedGeometries = [];
                                            this.spatialQueryService.filterSelectedLayers([bufferLayer], [], [], joinedGeometries);
                                            selectedLayers = this.bufferableLayers.filter(function (layer) { return _this.selectedLayers.includes(layer.id); });
                                            return [4 /*yield*/, this.spatialQueryService.spatialQueryLayers(true, selectedLayers, graphicsLayers_1)];
                                        case 1:
                                            results = _a.sent();
                                            spatialQueryParams = {
                                                primaryDynamicLayers: [],
                                                primaryFeatureLayers: [],
                                                joinedDynamicLayers: [],
                                                joinedFeatureLayers: [],
                                                joinedGeometries: joinedGeometries,
                                                isIntersect: true,
                                                guid: ''
                                            };
                                            title = "intersected by " + bufferLayer.title;
                                            return [4 /*yield*/, this.spatialQueryService.handleResults(results, spatialQueryParams, true, true, '', title)];
                                        case 2:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        bufferCompleted = true;
                        _a.label = 7;
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        error_1 = _a.sent();
                        this.LoggingService.Log('Error creating or applying buffer', error_1, LogLevel.Error);
                        return [3 /*break*/, 10];
                    case 9:
                        this.buffering = false;
                        this.buffered.emit(bufferCompleted);
                        return [7 /*endfinally*/];
                    case 10:
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], BufferComponent.prototype, "showOnlyApplicationUserMaps", void 0);
    return BufferComponent;
}(BaseComponent));
export { BufferComponent };
